"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  common: {
    query: 'Search',
    export: 'Export',
    exports: 'Batch Expert',
    save: 'Save',
    updates: 'Batch Update',
    saveAndAdd: 'Save & Add',
    submit: 'Submit',
    cancel: 'Cancel',
    goBack: 'Return',
    operation: 'Operation',
    edit: 'Edit',
    delete: 'Delete',
    detail: 'Details',
    reset: 'Reset',
    add: 'Add'
  },
  verification: {
    operationFailure: 'Operate failed',
    studyCircularLaws: 'Rules & Circulars Learn',
    assignedLearning: 'Assign Learn',
    companyNotice: 'Circulars',
    externalRegulations: 'External DOC.',
    today: 'Today',
    week: 'Week',
    mounth: 'Month',
    year: 'Year',
    applicationDate: 'Date',
    verificationMsg1: 'Can not be empty',
    verificationMsg2: 'Must be digital',
    verificationMsg3: 'File does not exist, please contact the administrator.'
  },
  circularCatalog: {
    index: {
      title: 'Circular & Regulation',
      item: 'Catalog',
      query: {
        itemName: 'Item Name'
      },
      table: {
        className: 'Catalog Name',
        remarks: 'Remark'
      },
      form: {
        parentId: 'Parent Catalog',
        standardNameCn: 'Catalog Name(Cn)',
        standardNameEn: 'Catalog Name(En)',
        dispOrder: 'Display Order',
        remarks: 'Remark'
      }
    }
  },
  circularManager: {
    index: {
      circularCatalog: 'Catalog Management',
      title: 'Circular & Regulation',
      item: 'Circular & Regulation Maintenance',
      deteleMessage: 'The catalog can not be deleted because it has child catalog',
      query: {
        itemName: 'Item Name',
        vessel: 'Related Vessel',
        dept: 'Created by',
        uploadDate: 'Uploaded Date',
        yes: 'Y',
        no: 'N',
        examination: 'Need Exam',
        async: 'Sync(Ship & Shore)',
        isValid: 'Valid',
        involveDept: 'Related Dept.',
        role: 'Related Post',
        deptMonitor: 'Monitor Dept.',
        roleMonitor: 'Monitor Post',
        circleWork: 'Circle Remind',
        syncFlag: 'Sync(Ship & Shore)'
      },
      table: {
        qualityFileNo: 'File No.',
        qualityFileName: 'File Name',
        qualityFileType: 'File Type',
        qualityFileStatus: 'Status',
        qualityFileDate: 'Effective Date',
        learnDeadline: 'Learned Deadline',
        learnDetail: 'Learned',
        feedbackDeadline: 'Implemented Deadline',
        actual: 'Implementation',
        attachmentsInfoId: 'Attachment',
        timeChoose: 'Select time ',
        vessel: 'Related Vessel',
        dept: 'Created by',
        qualityVersion: 'Version',
        async: 'Sync(Ship & Shore)',
        examination: 'Need Exam',
        systemFile: 'Manuals/Forms',
        circular: 'Circular',
        External: 'External DOC.',
        Supportive: 'Supportive File',
        Practices: 'Best Practices'
      },
      form: {
        applicableCompany: 'Applicable Company',
        file: 'File',
        fileProperties: 'File Properties',
        taskAllocation: 'Task Allocation',
        yes: 'Y',
        no: 'N',
        catalog: 'Catalog',
        qualityFileTyep: 'Type',
        qualityFileNo: 'File No.(Cn)',
        qualityFileNoEn: 'File No.(En)',
        qualityFileDate: 'Effective Date',
        qualityFileNameCn: 'File Name(Cn)',
        qualityFileNameEn: 'File Name(En)',
        qualityDueDate: 'Expired Date',
        resionRemark: 'Reason',
        sysOrgId: 'Department concerned',
        vesselCode: 'Ship concerned',
        examFlag: 'Need Exam',
        syncFlag: 'Sync(Ship & Shore)',
        learnFlag: 'If Learning',
        learnDeadline: 'Learned Deadline',
        learnDept: 'Department',
        learnShip: 'Ships',
        learnRemark: 'Learned Requirement',
        feedbackRemark: 'If Implementation',
        feedbackDeadline: 'Implemented Deadline',
        implementDept: 'Department',
        implementName: 'Monitor',
        implementShip: 'Ships',
        implementRemarks: 'Implementation Requirement',
        mainBody: 'File Text',
        upMainBody: 'Upload File',
        attachmentsInfoId: 'Attachment',
        uploadAttachment: 'Upload Attachment',
        responsibleDepartment: 'Responsible Department',
        uploader: 'Uploaded by',
        uploadDate: 'Uploaded Date',
        sync: 'Y',
        unSync: 'N',
        exam: 'Y',
        unExam: 'N',
        effectiveFlag: 'Valid',
        effective: 'Valid',
        unEffective: 'Invalid',
        overdueDate: 'Expired Date',
        selectOverdueDate: 'Please select the expiration date'
      }
    }
  }
};